import { IssueTypeActionTypes } from "./constants";

export const issueTypeApiResponseSuccess = ( actionType = '', data = {} ) => ({
    type: IssueTypeActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const issueTypeApiResponseError = ( actionType = '', error = '' ) => ({
    type: IssueTypeActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error }
});

export const getIssueTypeList = (params) => {
    return {
        type: IssueTypeActionTypes.GET_ISSUE_TYPE_LIST,
        payload: { params },
    }
};

export const getIssueTypeId = (issue_type_id) => {
    return {
        type: IssueTypeActionTypes.GET_ISSUE_TYPE_ID,
        payload: { issue_type_id },
    }
};

export const addIssueType = (params) => {
    return {
        type: IssueTypeActionTypes.ADD_ISSUE_TYPE,
        payload: params
    }
};

export const addIssueTypeInstant = (params) => {
    return {
        type: IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT,
        payload: params,
    }
};

export const updateIssueType = ( params ) => {
    return {
        type: IssueTypeActionTypes.UPDATE_ISSUE_TYPE,
        payload: params,
    }
};

export const deleteIssueType = (issue_type_id = Number) => {
    return {
        type: IssueTypeActionTypes.DELETE_ISSUE_TYPE,
        payload: issue_type_id
    }
};

export const resetIssueTypeUpdate = (list) => {
    return {
        type: IssueTypeActionTypes.RESET_ISSUE_TYPE_UPDATE,
        payload: list
    }
};

export const resetIssueType = () => {
    return {
        type: IssueTypeActionTypes.RESET_ISSUE_TYPE,
        payload: {},
    }
};